/* Built In Imports */
'use client';
import React, { createRef, useEffect, useRef, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Select,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import parser from 'html-react-parser';
import forEach from 'lodash/forEach';
import { nanoid } from 'nanoid';
import ReCAPTCHA from 'react-google-recaptcha';

/* Internal Imports */
/* Components */
import config from '@config';
import { CountriesList } from '../../../constants';

/* Services */
import { addHomeSubscribeData } from 'services/commonService';
/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';
import SimpleButton from "@app-kb/Components/Buttons/SimpleButton";
import { modifyDatoImgUrlToStatic } from "../../../app/landing_pages/karma/Components/utils";

/**
 * Renders the Subscribe Box component
 *
 * @param {object} newsletters
 * @param {string} type
 * @param {string} inputBackground
 * @param {string} submitText
 * @param {boolean} hideSpamText Want to show Spam text or not
 * @param type
 * @param inputBackground
 * @param submitText
 * @param hideSpamObj
 * @param hideSpamText
 * @returns {ReactElement} Subscribe Box component.
 */

const SubscribeBoxV2 = ({
  newsletters,
  type,
  inputBackground,
  submitText,
  hideSpamObj,
  hideSpamText,
  region, language, articleData
}) => {
  const [isLoading, setLoading] = useState(false);
  const [messageTemp, setMessageTemp] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = useRef(null);
  const emailRegex = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,15}$/i;
  const nameRegex = /[A-Za-z]/;
  const countries = CountriesList;
  const ref = useRef(null);
  const recaptchaRef = createRef();

  React.memo(countries);


  /**
   *
   * @param value
   */
  function validateName(value) {
    let error;
    if (!value) error = 'Name is required';
    if (!value.match(nameRegex)) error = 'Full Name accepts only alphabets';
    return error;
  }

  /**
   *
   * @param value
   */
  function validateEmail(value) {
    let error;
    if (!value) error = 'Email is required';
    if (!value.match(emailRegex)) error = 'Invalid Email';
    return error;
  }

  /**
   *
   * @param value
   */
  function validateCountry(value) {
    let error;
    if (!value) error = 'Select Country';
    return error;
  }

  /**
   *
   * @param value
   */
  function validateReCaptcha(value) {
    let error;
    if (!value) error = 'Please verify you are human!';
    return error;
  }

  // const mixpanelevent = () => {
  //   if (router.asPath.indexOf("/yoga-meditation/yoga-program-for-beginners/isha-kriya-meditation") > -1) {
  //     const Mixpanel = mixPanel(window?.location.pathname);
  //     Mixpanel.track("yoga_meditation_email_support_signup", {
  //       program_name: "Isha Kriya",
  //       program_type: "Beginners programs",
  //       page_name: document.title,
  //       program_source: router?.query?.source ? router?.query?.source : "direct",
  //       cta: "bottom",
  //       element: "Sign Up",
  //     });
  //   }

  // }

  /**
   *
   * @param url
   */
  function getUrlParameter(url) {
    let URLVariables = url?.split('&'),
      parameterName,
      result = {};

    forEach(URLVariables, function (parameter) {
      parameterName = parameter.split('=');

      result = {
        ...result,
        [parameterName[0]]: decodeURIComponent(parameterName[1]),
      };
    });

    // parameterName = URLVariables[i].split('=');

    // result = {
    //   ...result,
    //   [parameterName[0]]: decodeURIComponent(parameterName[1]),
    // };
    return result;
  }

  useEffect(() => {
    if (!isOpen && typeof window !== undefined && window?.location?.href?.indexOf('popup=1') > -1) {
      const parentUrl =
        location.origin +
        location.pathname +
        location.search.replace(/[\?&]popup=1/, '').replace(/^&/, '?');
      window.history.pushState(window.history.state, '', parentUrl);
    }
    recaptchaRef?.current?.reset();
  }, [isOpen]);

    
  let jsonStructuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `https://isha.sadhguru.org/karma/articles/${articleData?.urlAlias}`,
    "headline": articleData?.title,
    "description": articleData?.summary,
    "author": {
      "@type": "Person",
    "@id": "https://isha.sadhguru.org/#sadhguru",
      "name": "Sadhguru"
    },
    "datePublished": articleData?._publishedAt,
    "image": modifyDatoImgUrlToStatic(articleData?.heroImage?.url)
  } 
  
  

  return (
    <Box>
      <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonStructuredData) }}
        />
      <Flex
        w={{ base: '', sm: '', md: '' }}
        flexFlow={{ base: 'column' }}
        // flexWrap="wrap"
        pos="relative"
        height={{ base: '750px', lg: '648px' }}
        justifyContent="center"
        alignItems={'center'}
        background={`linear-gradient(180deg, #030040 0%, #030040 100%)`}
      >
        <Image
          src="https://www.datocms-assets.com/46272/1754979023-subscribeformbg.png"
          pos={'absolute'}
          top={'0'}
          width={'100%'}
        />
        <Box mb={{base: '2rem', md: '3rem'}}>
          <Text
            textAlign={'center'}
            fontFamily={'var(--AustinMedium)'}
            color={'#7B7997'}
            fontSize={{ base: '34px', md: '60px' }}
            lineHeight={{ base: '36px', md: '67px' }}
          >Subscribe</Text>
          <Text
            textAlign={'center'}
            fontFamily={'var(--FedraSansStd-book)'}
            color={'#FFFFFF'}
            fontSize={{ base: '16px', md: '14px' }}
            lineHeight={{ base: '26px', md: '22px' }}
            px={{base:'50px', md: '0px'}}
            mt={{base: '0px', lg: '10px'}}
          >Get weekly updates on the latest blogs via newsletters right in your mailbox.</Text>
        </Box>
        <Box>
        <Formik
          initialValues={{ name: '', email: '', country: '', recaptcha: '' }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const { name, email, country } = values;
            setLoading(true);
            const data = addHomeSubscribeData({
              name,
              email,
              country,
              language: language?.toUpperCase() || "EN",
              newsletters,
              type,
              source: typeof window !== 'undefined' ? `${config.cdnPath}${window.location.pathname}` : '',
            });
            data.then(formResponse => {           
              if (newsletters === 'EuropeNewsletter') {
                let url, pathURL, paramsURL;
                // consoleLog('response', response);
                if (formResponse.status === 'Success') {
                  // consoleLog('Success response');
                  const index = formResponse?.redirectURL?.indexOf(`/in/en/`);
                  if (index != -1) {
                    url = formResponse.redirectURL.substr(index);
                    pathURL = url.split('?')?.[0];
                    paramsURL = getUrlParameter(url.split('?')?.[1]);
                  } else {
                    pathURL = `/${region}/${language}/subscribe-confirmation`;
                  }
                } else {
                  pathURL = `/${region}/${language}/subscribe-failure`;
                }
                // router.push({
                //   pathname: pathURL,
                //   query: {
                //     ...paramsURL,
                //   },
                // });
                const queryString = new URLSearchParams(paramsURL).toString();
                const newUrl = `${pathURL}${queryString ? `?${queryString}` : ''}`;
                if(typeof window !== 'undefined'){
                  window.history.pushState({}, '', newUrl);
                }
                // mixpanelevent();
              } else {
                resetForm();
                if (typeof formResponse === 'string') {
                  setMessageTemp(
                    `<div>Sorry something went wrong. We are not able to process your request right now.</div>`
                  );
                } else if (
                  formResponse[0]?.status_code === 101 ||
                  formResponse[0]?.status_code === 102 ||
                  formResponse[0]?.status_code === 103 ||
                  formResponse[0]?.status_code === 104 ||
                  formResponse[0]?.status_code === 105 ||
                  formResponse[0]?.status_code === 106
                ) {
                  setMessageTemp(formResponse[0]?.message_template);
                } else {
                  setMessageTemp(
                    `<div>Sorry something went wrong. We are not able to process your request right now.</div>`
                  );
                }
                onOpen();
                setLoading(false);
                if(typeof window !== undefined){
                  window?.dataLayer?.push({
                    event: 'newsletter_success',
                    source: `${config.cdnPath}${window.location.pathname}`,
                  });
                  const popupUrl =
                  window.location.pathname.indexOf('?popup=1') > -1
                      ? window.location.pathname
                      : window.location.pathname.indexOf('?') > -1
                        ? `${window.location.pathname}&popup=1`
                        : `${window.location.pathname}?popup=1`;
                  window.history.pushState(window.history.state, '', popupUrl);
                  window['loc'] = popupUrl;
                }
                // mixpanelevent();
              }
            });
          }}
        >
          {props => (
            <Form>
              <Box
                display={{ base: 'block', xl: 'flex' }}
                m={{ base: '0 3%', lg: 'unset' }}
                justifyContent="space-between"
              >
                <Field name="name" validate={validateName}>
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form?.errors?.name && form?.touched?.name}
                      width={{ base: '100%', xl: 'calc((100% - 40px)/3)' }}
                      m={{ base: '0 0 18px 0', xl: '0' }}
                    >
                      <Text mb={'10px'} fontFamily={'var(--FedraSansStd-book)'} fontSize={'16px'} lineHeight={'20px'}
                        color={'#FFFFFF'}>Full Name<span style={{ color: 'red' }}>*</span></Text>
                      <Input
                        {...field}
                        id="name"
                        variant="outline"
                        isRequired={true}
                        placeholder=""
                        fontFamily="var(--FedraSansStd-book)"
                        fontSize="18px"
                        color="#8a8173"
                        height={{ base: '50px', lg: '40px' }}
                        padding="10px"
                        borderRadius="3px"
                        border="1px solid #a1a1a1"
                        p="20px"
                        mr="20px"
                        width={{ base: '320px', md: '268px' }}
                        backgroundColor={inputBackground}
                      />
                      <FormErrorMessage justifyContent="center">
                        {form?.errors?.name}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="email" validate={validateEmail}>
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form?.errors?.email && form?.touched?.email}
                      width={{ base: '100%', xl: 'calc((100% - 40px)/3)' }}
                      m={{ base: '0 0 18px 0', xl: '0' }}
                    >
                      <Text mb={'10px'} fontFamily={'var(--FedraSansStd-book)'} fontSize={'16px'} lineHeight={'20px'}
                        color={'#FFFFFF'}>Email Address<span style={{ color: 'red' }}>*</span></Text>
                      <Input
                        {...field}
                        id="email"
                        variant="outline"
                        isRequired={true}
                        placeholder=""
                        fontFamily="var(--FedraSansStd-book)"
                        fontSize="18px"
                        color="#8a8173"
                        height={{ base: '50px', lg: '40px' }}
                        padding="10px"
                        borderRadius="3px"
                        border="1px solid #a1a1a1"
                        p="20px"
                        type="email"
                        backgroundColor={inputBackground}
                        width={{ base: '320px', md: '268px' }}
                      />
                      <FormErrorMessage justifyContent="center">
                        {form?.errors?.email}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="country" validate={validateCountry}>
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form?.errors?.country && form?.touched?.country}
                      width={{ base: '100%', xl: 'calc((100% - 40px)/3)' }}
                      m={{ base: '0 0 18px 0', lg: '0' }}
                    >
                      <Text mb={'10px'} fontFamily={'var(--FedraSansStd-book)'} fontSize={'16px'} lineHeight={'20px'}
                        color={'#FFFFFF'}>Country<span style={{ color: 'red' }}>*</span></Text>
                      <Select
                        key="country"
                        {...field}
                        id="country"
                        // width="100%"
                        isRequired={true}
                        placeholder="Select"
                        fontFamily="var(--FedraSansStd-book)"
                        fontSize="18px"
                        color="#8a8173"
                        height={{ base: '50px', lg: '40px' }}
                        borderRadius="3px"
                        border="1px solid #a1a1a1"
                        backgroundColor={inputBackground}
                        width={{ base: '320px', md: '268px' }}
                      >
                        {countries.map(country => {
                          if (newsletters === 'EuropeNewsletter') {
                            return (
                              country?.region === 'eu/en' && (
                                <option key={nanoid()} value={country?.value}>
                                  {country?.name}
                                </option>
                              )
                            );
                          } else {
                            return (
                              <option key={nanoid()} value={country?.value}>
                                {country?.name}
                              </option>
                            );
                          }
                        })}
                      </Select>
                      <FormErrorMessage justifyContent="center">
                        {form?.errors?.country}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </Box>
              <Box
                display="flex"
                ref={ref}
                justifyContent="center"
                mt={{base: '30px', md: "35px"}}
                mb={{base: '10px', md: '35px'}}
                mr={{ base: 0 }}
              >
                <Field name="recaptcha" validate={validateReCaptcha}>
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form?.errors?.recaptcha && form?.touched?.recaptcha
                      }
                      width={'auto'}
                      m={{ base: '0 0 18px 0', xl: '0' }}
                    >
                      {config?.RECAPTCHA_KEY && (
                        <ReCAPTCHA
                          width={'100%'}
                          // size="compact"
                          ref={recaptchaRef}
                          sitekey={config?.RECAPTCHA_KEY}
                          onChange={success => {
                            success === null
                              ? recaptchaRef?.current?.reset()
                              : props.setFieldValue('recaptcha', success);
                          }}
                          onErrored={error => {
                            props.setFieldValue('recaptcha', '');
                            recaptchaRef?.current?.reset();
                          }}
                        />
                      )}
                      <FormErrorMessage justifyContent="center">
                        {form?.errors?.recaptcha}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </Box>
              <Box marginTop={{base: '10px', md:"20px"}}>
                <Box textAlign="center" mt={{base: '10px', md:"20px"}}>
                  <Button
                    type="submit"
                    isLoading={isLoading}
                    fontSize={{
                      base: '22px',
                      lg: '28px',
                    }}
                    textAlign={"center"}
                    lineHeight={'68px'}
                    border="2px solid #fff"
                    fontFamily="var(--AustinMedium)"
                    fontWeight="500"
                    // _active={{
                    //   border: 'none',
                    //   background: '#000054',
                    // }}
                    // margin="0 auto"
                    className="orange-button"
                    // mb="10px"
                    // display="block"
                    bgColor="transparent"
                    h={'68px'}
                    pr={'4rem'}
                    // minW="200px"
                    // padding={'14px 29px'}
                    borderRadius="10px"
                    color="#fff"
                    textDecoration="none"
                    width={{ base: '185px', md: '223px' }}
                  // _hover={{
                  //   bg: '#000054',
                  // }}
                  //onClick={()=>mixpanelevent(submitText || 'Subscribe')}
                  >
                    {submitText}
                    <Box position={'absolute'} right={{ base: '3rem', md: '3rem', lg: "3rem" }} top={{ base: '42%', md: '44%', }}>
                      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.8333 1.5L16.3333 6.99998M16.3333 6.99998L10.8333 12.5M16.3333 6.99998L1.66658 6.99998" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </Box>
                  </Button>
                </Box>
                {!hideSpamText ||
                  (hideSpamObj && (
                    <Box
                      fontFamily="var(--FedraSansStd-book)"
                      fontSize={{ base: '', sm: '', md: '16px', lg: '16px' }}
                      lineHeight="1.56"
                      textAlign="center"
                      color="#171717"
                      padding={{ base: '7px 19px', sm: '7px 19px' }}
                    >
                      {hideSpamObj || 'No Spam. Cancel Anytime.'}
                    </Box>
                  ))}
              </Box>
            </Form>
          )}
        </Formik>
        </Box>
        <style jsx global>{`
          ::placeholder {
            color: #a1a1a1;
          }
        `}</style>
        
      {messageTemp && (
        <Box
          // m="20px auto"
          maxW={messageTemp ? { base: '95%', md: '476px', lg: '822px' } : 'auto'}
        >
          <Modal
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
            isCentered
            motionPreset="slideInBottom"
            size={'xl'}
            blockScrollOnMount={true}
            closeOnOverlayClick={false}
          // scrollBehavior="inside"
          >
            <ModalOverlay />
            <ModalContent  px={{base:"0px", md: '30px'}} 
            py={{base:"30px", md: '30px'}} bg="#EFE7D6">
              <ModalCloseButton color="#B7870C" mt="1" />
              <ModalBody id='subscribeFormModal' fontFamily={'var(--FedraSansStd-book)'} fontSize={{ base: '20px' }} lineHeight={{ base: '34px' }}>{parser(messageTemp || '')}</ModalBody>
            </ModalContent>
          </Modal>
        </Box>
      )}
      </Flex>
      <style>
        {`#subscribeFormModal {
          font-family: var(--FedraSansStd-book) !important;
          font-size: 20px !important;
          line-height: 34px !important;
          color: #000000 !important;
        }
        #subscribeFormModal em {
          font-style: normal !important;
        }
        #subscribeFormModal b {
          font-weight: 600 !important;
        }
        #subscribeFormModal > section > div:first-child p {
          color: #030040 !important;
          font-family: var(--AustinMedium) !important;
          font-size: 36px !important;
          line-height: 60px !important;
          margin-bottom: ${useBreakpointValue({base: '0.5rem', md: '1rem'})} !important;
        }
        #subscribeFormModal p {
          margin-bottom: ${useBreakpointValue({base: '1rem', md: '2rem'})} !important;
        }
        `}
      </style>
    </Box>
  );
};

export default SubscribeBoxV2;
